import { render, staticRenderFns } from "./GroupTable.global.vue?vue&type=template&id=13d9c596&lang=pug&"
import script from "./GroupTable.global.vue?vue&type=script&lang=ts&"
export * from "./GroupTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports